import React from "react";
import { Box, Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { accentColor } from "./resultatsTheme";

interface ResultatsHeaderProps {
  title?: string;
  subtitle?: string;
}

export default function ResultatsHeader({
  title = "Résultats",
  subtitle = "Tirage des poules, classements et tableau final.",
}: ResultatsHeaderProps): React.ReactElement {
  const theme = useTheme();

  return (
    <Box
      component="header"
      sx={{
        mb: { xs: 2.5, md: 3.5 },
        pb: { xs: 2, md: 2.5 },
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
      <Stack spacing={0.85}>
        <Typography
          variant="overline"
          sx={{
            letterSpacing: "0.16em",
            fontWeight: 700,
            color: accentColor(theme),
            lineHeight: 1.2,
          }}
        >
          SQY Ping · Tournoi
        </Typography>
        <Typography
          variant="h3"
          component="h1"
          sx={{
            fontWeight: 800,
            fontSize: { xs: "1.85rem", sm: "2.25rem", md: "2.55rem" },
            letterSpacing: "-0.03em",
            lineHeight: 1.08,
          }}
        >
          {title}
        </Typography>
        {subtitle ? (
          <Typography
            variant="body1"
            color="text.secondary"
            sx={{
              maxWidth: 560,
              lineHeight: 1.55,
              fontSize: { xs: "0.95rem", md: "1.02rem" },
            }}
          >
            {subtitle}
          </Typography>
        ) : null}
      </Stack>
    </Box>
  );
}
